import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore(
  'real-estate-developments-accessories',
  storeModule.createStoreModule('real-estate-developments-accessories')
)
